// src/hooks/useCurrency.js
// Fetches currency from the backend (server-side IP detection).
// Returns { symbol, isUK, loading } — symbol is '£' or '$', isUK is true for GBP.
// Shows prices exactly as set (no conversion) — just swaps the symbol.

import { useState, useEffect } from 'react';
import { API } from '../utils/constants';

let _cached = null; // module-level cache so all components share one fetch

export function useCurrency() {
  const [state, setState] = useState(
    _cached
      ? { symbol: _cached.symbol, isUK: _cached.currency === 'GBP', loading: false }
      : { symbol: '£', isUK: true, loading: true }
  );

  useEffect(() => {
    if (_cached) return; // already fetched this session

    let cancelled = false;
    fetch(`${API}/currency`)
      .then(r => r.json())
      .then(data => {
        if (cancelled) return;
        _cached = data;
        setState({ symbol: data.symbol, isUK: data.currency === 'GBP', loading: false });
      })
      .catch(() => {
        if (cancelled) return;
        // Fallback: default to GBP
        _cached = { currency: 'GBP', symbol: '£' };
        setState({ symbol: '£', isUK: true, loading: false });
      });

    return () => { cancelled = true; };
  }, []);

  return state;
}

/**
 * Format a price using the detected currency symbol.
 * No conversion — £4.99 becomes $4.99 for USD users, £4.99 for GBP users.
 *
 * @param {number} price  - price in GBP (e.g. 4.99)
 * @param {string} symbol - '£' or '$'
 */
export function fmtPrice(price, symbol) {
  return `${symbol}${price.toFixed(2)}`;
}
